module.exports = __webpack_public_path__ + "static/media/not-available.8dc2c281.jpg";